/**
 * @generated SignedSource<<138f60dc6d76def64832ef05f5fbefae>>
 * @relayHash 0a32472f8d2692b5a56b369b553b7aa3
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID d9c9dc901020a4b405d71aeeae70024adb7c2d54ae9c257234a350d2c9ed31d0

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type pickerContentRefetchQuery$variables = {
  cloudId: string;
  isVerticalsAgentPickerEnabled: boolean;
  issueAris?: ReadonlyArray<string> | null | undefined;
  searchStr?: string | null | undefined;
};
export type pickerContentRefetchQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"pickerContent_autodevAgentPicker_agentsFragRef">;
};
export type pickerContentRefetchQuery = {
  response: pickerContentRefetchQuery$data;
  variables: pickerContentRefetchQuery$variables;
};
({
  "isVerticalsAgentPickerEnabled": isVerticalsAgentPickerEnabled_provider,
  "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": isVerticalsAgentPickerEnabled_provider
} as {
  readonly __relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider: {
    readonly get: () => boolean;
  };
  readonly isVerticalsAgentPickerEnabled: {
    readonly get: () => boolean;
  };
});

import isVerticalsAgentPickerEnabled_provider from '@atlassian/jira-relay-provider/src/autodev-is-verticals-agent-picker-enabled.relayprovider';

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "isVerticalsAgentPickerEnabled"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "issueAris"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "searchStr"
},
v4 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v5 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/)
    ],
    "kind": "Fragment",
    "name": "pickerContentRefetchQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "issueAris",
            "variableName": "issueAris"
          },
          {
            "kind": "Variable",
            "name": "searchStr",
            "variableName": "searchStr"
          }
        ],
        "kind": "FragmentSpread",
        "name": "pickerContent_autodevAgentPicker_agentsFragRef"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider"
      }
    ],
    "kind": "Operation",
    "name": "pickerContentRefetchQuery",
    "selections": [
      {
        "condition": "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
          {
            "args": [
              (v4/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 20
              },
              {
                "kind": "Variable",
                "name": "issueIds",
                "variableName": "issueAris"
              },
              {
                "kind": "Variable",
                "name": "query",
                "variableName": "searchStr"
              }
            ],
            "concreteType": "DevAiRovoAgentConnection",
            "kind": "LinkedField",
            "name": "devai_autodevRovoAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevAiRovoAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "DevAiRovoAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      (v5/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "identityAccountId"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "externalConfigReference"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "rankCategory"
                      }
                    ]
                  }
                ]
              }
            ]
          },
          {
            "alias": "devai_autodevRovoTemplates",
            "args": [
              (v4/*: any*/),
              {
                "kind": "Literal",
                "name": "first",
                "value": 1
              },
              {
                "kind": "Literal",
                "name": "templatesFilter",
                "value": "ONLY"
              }
            ],
            "concreteType": "DevAiRovoAgentConnection",
            "kind": "LinkedField",
            "name": "devai_autodevRovoAgents",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevAiRovoAgentEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "concreteType": "DevAiRovoAgent",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v5/*: any*/)
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "d9c9dc901020a4b405d71aeeae70024adb7c2d54ae9c257234a350d2c9ed31d0",
    "metadata": {},
    "name": "pickerContentRefetchQuery",
    "operationKind": "query",
    "text": null,
    "providedVariables": {
      "isVerticalsAgentPickerEnabled": isVerticalsAgentPickerEnabled_provider,
      "__relay_internal__pv__atlassianjirarelayprovidersrcautodevisverticalsagentpickerenabledrelayprovider": isVerticalsAgentPickerEnabled_provider
    }
  }
};
})();

(node as any).hash = "c750a5797af80df44df84bd82c9ff4fa";

export default node;
